import { Regions } from '@customTypes/Region';
import { Services } from '@customTypes/Service';

export function serviceName(id: number, services: Services) {
  const service = services?.find((s) => s.id == id);
  if (!service) return '알 수 없는 서비스';
  return service.display_name;
}

export function serviceBookingCode(id: number, services: Services) {
  const service = services?.find((s) => s.id == id);
  if (!service) return 'homeclean';
  return service.code;
}

export function regionName(id: number, regions: Regions) {
  const region = regions.find((r) => r.id == id);
  if (!region) return '알 수 없는 지역';
  return region.full_name;
}
